// Parent title inside <summary> should navigate on single tap.
// Anywhere else on the <summary> (including Dawn's arrows) should toggle.

(function () {
  // Block <summary> toggling as early as possible when tapping the link (iOS fix)
  document.addEventListener('pointerdown', function (e) {
    const link = e.target.closest('summary a.menu-drawer__parent-link');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  // Then perform the navigation on click
  document.addEventListener('click', function (e) {
    const link = e.target.closest('summary a.menu-drawer__parent-link');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(link.href);
  }, true);

  // Keyboard support
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const link = e.target.closest('summary a.menu-drawer__parent-link');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(link.href);
  }, true);
})();
